import { createWithEqualityFn as create } from 'zustand/traditional';

interface State {
  opened: boolean;
  setOpened: (opened: boolean) => void;
}

export const useNotificationsLogStore = create<State>((set) => ({
  opened: false,
  setOpened: (opened) => set({ opened }),
}));